import { Routes } from '@angular/router';
import {
  ASSESSMENT_ID_PATH_PARAM,
  ASSESSMENT_VIEW_PATH,
  CREATE_ASSESSMENT_PATH,
  HELP_SUPPORT,
  HOME_PATH,
} from '../../../../../values/path';

export const FULL_ROUTES: Routes = [
  {
    path: CREATE_ASSESSMENT_PATH,
    loadComponent: () =>
      import(
        '../../components/create-assessment/create-assessment.component'
      ).then(
        (createAssessmentModule) =>
          createAssessmentModule.CreateAssessmentComponent
      ),
  },
  {
    path: `${ASSESSMENT_VIEW_PATH}/:${ASSESSMENT_ID_PATH_PARAM}`,
    loadComponent: () =>
      import('../../components/assessment-view/assessment-view.component').then(
        (assessmentModule) => assessmentModule.AssessmentViewComponent
      ),
  },
  {
    path: HOME_PATH,
    loadComponent: () =>
      import('../../components/home/home.component').then(
        (homeModule) => homeModule.HomeComponent
      ),
  },
  {
    path: HELP_SUPPORT,
    loadComponent: () =>
      import('../../components/help-support/help-support.component').then(
        (helpAndSupportComponent) =>
          helpAndSupportComponent.HelpSupportComponent
      ),
  },
];
